<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div>
          <div class="headline">Coverage Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.cvrType }}</td>
          <td class="text-xs-left">{{ props.item.cvrTypeDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview(props.item.cvrType)" remove @remove="doPromptDelete(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Coverage<v-icon>mdi-plus</v-icon></v-btn>
      <confirm v-model="promptRemove" @ok="doDelete">
        Are you sure you want to delete the selected coverage?
        <div class="title">{{selectedCvr.text}}</div>
      </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'Coverage Code', value: 'cvrType' },
        { text: 'Coverage Description', value: 'cvrTypeDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'Coverage Details',
        cvrType: 'Coverage Code',
        cvrTypeDesc: 'Coverage Description'
      },
      coverForm: {
        cvrType: null,
        cvrTypeDesc: null
      },
      coverDialog: null,
      newCoverage: null,
      sumbitting: undefined,
      selectedCvr: {
        id: null,
        text: null
      },
      promptRemove: false
    }
  },
  computed: {
    coverage() {
      return this.$store.state.parameters.coverage
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiURI = this.coverage.menu.getCovers
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((cover) => {
              const convertCover = {
                cvrType: cover.cvrType,
                cvrTypeDesc: cover.cvrTypeDesc
              }
              this.items.push(convertCover)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    doReview(cvrType) {
      const redirect = {
        name: 'coverageReview',
        params: {
          cvrType
        }
      }
      this.$router.push(redirect)
    },
    doNew() {
      const redirect = {
        name: 'coverageReview',
        params: {
          cvrType: 'new'
        }
      }
      this.$router.push(redirect)
    },
    doPromptDelete(cover) {
      this.resetMessages()
      this.selectedCvr.id = cover.cvrType
      this.selectedCvr.text = cover.cvrType + ' - ' + cover.cvrTypeDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.coverage.menu.deleteCover
      if (apiURI) {
        const expand = {
          cover: this.selectedCvr.id
        }
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.init()
          this.selectedCvr.id = null
          this.selectedCvr.text = null
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  created() {
    this.init()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
